import React from 'react';
import { Button, PageHeader, PageHeaderTools, PageHeaderToolsGroup, PageHeaderToolsItem } from '@patternfly/react-core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { getAppDeploymentInfo, selectClientList, selectIsHelpDocumentAvailable } from './store/selectors';
import ClientSelector from './components/client-selector';
import { StoreState } from './store/reducers';
import { DEFAULT_APP_NAME } from './environments';
import { CogIcon, QuestionCircleIcon } from '@patternfly/react-icons'
import TiltButton from './components/tilt-button';
import routes from './routes';

import logo32w from './img/mvision-logo-white-32.png';
import { DeploymentMode } from './store/deployment-config-info';
import { getCurrentLangKey } from './i18n';

interface MastheadAndHeaderProps {
    handleOpenUserSettings: () => void,
    handleOpenHelpDialog: () => void,
    isUserSettingsOpen: boolean,
}

const Masthead = (props: MastheadAndHeaderProps) => {

    const { t } = useTranslation();

    return (
        <PageHeader className="mv-masthead" logo={(<span className="masthead-logo" title={t('appTitle')}><img src={logo32w} alt="MVision logo"/></span>)} logoComponent={Link} logoProps={{to: routes.homePage.slug}} showNavToggle headerTools={(<HeaderTools {...props} />)} />
    );
};

const HeaderTools = (props: MastheadAndHeaderProps) => {

    const appClientList = useSelector(selectClientList);
    const deploymentInfo = useSelector(getAppDeploymentInfo);
    const currentAppClient = useSelector((state: StoreState) => state.currentAppClient);
    const currentLangKey = getCurrentLangKey();
    const isHelpDocumentAvailable = useSelector((state: StoreState) => selectIsHelpDocumentAvailable(state, currentLangKey));


    // TODO: support UI case where user has only one app client and has no reason to use a dropdown selector
    // const showSingleClient = appClientList && appClientList.length === 1;
    const showClientSelector = appClientList && deploymentInfo && deploymentInfo.deploymentMode !== DeploymentMode.Local;
    const hiddenClientSelector = /*config.showDebugInfoInUi && */currentAppClient && currentAppClient.localMode
        ? (<div title={`${DEFAULT_APP_NAME} is using local configuration API.`}>Local mode</div>) : null;

    return (
        <PageHeaderTools>
            <PageHeaderToolsGroup>
                <PageHeaderToolsItem>
                    {showClientSelector ? (<ClientSelector clientList={appClientList} />) : hiddenClientSelector}
                </PageHeaderToolsItem>
                <PageHeaderToolsItem>
                    {isHelpDocumentAvailable && <Button onClick={props.handleOpenHelpDialog} variant="plain"><QuestionCircleIcon size="md" /></Button>}
                    <TiltButton forceTilt={props.isUserSettingsOpen} tiltOrigin="12px 12px" onClick={props.handleOpenUserSettings}><CogIcon size="md" /></TiltButton>
                </PageHeaderToolsItem>
            </PageHeaderToolsGroup>
        </PageHeaderTools>
    );

}

export default Masthead;

